import {Component, Input, OnChanges, TemplateRef, ViewChild} from '@angular/core';
import {StudentService} from '../../services/student.service';
import {NgForm} from '@angular/forms';
import {DataType, Header, SortableTableComponent} from '../../components/helpers/sortableTable/sortableTable.component';

import {Level, ToastService} from '../../services/toast.service';
import {PrintOptions} from '../../common/components/buttons/print-options.helper';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {BehaviorInterventionDto} from '@sidr/dto-types';

@Component({
  selector: `student-bhvrintv`,
  templateUrl: 'student.behaviorinterventions.html'
})
export class StudentBehaviorInterventionsComponent implements OnChanges {
  createBhvrIntv(content: TemplateRef<any>) {
    this.modalBhvr = this.newBhvr();
    this.modalService.open(content, {centered: true});
  }

  editBhvrIntv(bhvr: BehaviorInterventionDto, content: TemplateRef<any>) {
    this.modalBhvr = {...bhvr};
    this.modalService.open(content, {centered: true});
  }

  @ViewChild(SortableTableComponent) public Table: SortableTableComponent;
  @Input() printOptions: PrintOptions;
  @Input() districtId: string;
  @Input() studentId: string;
  headers: Header[];
  keepModalOpen: boolean = true;

  maxdate: string;

  bhvrintvs: BehaviorInterventionDto[];
  modalBhvr: BehaviorInterventionDto;

  NotificationTitle = 'Behavior Interventions';

  today(): string {
    const now = new Date(Date.now());
    let month = (now.getMonth() + 1).toString();
    if (month.length === 1) {
      month = '0' + month;
    }
    let day = now.getDate().toString();
    if (day.length === 1) {
      day = '0' + day;
    }
    return `${now.getFullYear()}-${month}-${day}`;
  }

  newBhvr(): BehaviorInterventionDto {
    const bhvr:BehaviorInterventionDto = {
      behavior: '',
      intervention: '',
      importTag: '',
      date: this.today()
    };
    return bhvr;
  }

  constructor(
    private studentService: StudentService,
    private toastService: ToastService,
    private modalService: NgbModal) {
    this.maxdate = this.today();
    this.modalBhvr = this.newBhvr();
    this.headers = [];
    this.headers.push(new Header('Date', 'date', false, DataType.Date, {
      dateFormat: 'shortDate'
    }));
    this.headers.push(new Header('Behavior', 'behavior', false, DataType.String));
    this.headers.push(new Header('Intervention', 'intervention', false, DataType.String));
  }

  del(d: BehaviorInterventionDto) {
    this.studentService.deleteBehaviorIntervention(this.districtId, this.studentId, d.id!).subscribe(resp => {
      this.toastService.AddNotification(Level.SUCCESS, this.NotificationTitle, 'Removed Behavior Intervention');
      this.getData();
    });
  }

  save(d: BehaviorInterventionDto, form: NgForm) {
    if (form.invalid) {
      return;
    }
    (d.id && d.id.length > 0 ?
        this.studentService.patchBehaviorIntervention(this.districtId, this.studentId, d) :
        this.studentService.postBehaviorIntervention(this.districtId, this.studentId, d)
    ).subscribe(resp => {
      this.toastService.AddNotification(Level.SUCCESS, this.NotificationTitle, 'Saved Behavior Intervention');
      this.getData();
      this.Table.clear();
      if (d.id) {
        this.modalService.dismissAll();
      }
      if (d.id || (!d.id && !this.keepModalOpen)) {
        this.modalService.dismissAll();
      }
      this.modalBhvr = this.newBhvr();
      form.form.markAsPristine();
      form.form.markAsUntouched();
    }, err => {
      this.toastService.AddNotification(Level.ERROR, this.NotificationTitle, 'Error saving Behavior Intervention');
    });
  }

  submit(form: NgForm) {
    this.studentService.postBehaviorIntervention(this.districtId, this.studentId, this.modalBhvr).subscribe(resp => {
      this.modalBhvr = this.newBhvr();
      form.form.reset();
      this.getData();
    });
  }

  delete(id: string) {
    this.studentService.deleteBehaviorIntervention(this.districtId, this.studentId, id).subscribe(resp => {
      this.getData();
    });
  }

  ngOnChanges(): void {
    if (this.districtId && this.studentId) {
      this.getData();
    }
  }

  getData() {
    this.studentService.getBehaviorIntervention(this.districtId, this.studentId).subscribe(resp => {
      this.bhvrintvs = resp || [];
      if (resp !== null) {
        this.bhvrintvs.sort((a: BehaviorInterventionDto, b: BehaviorInterventionDto) => {
          return a.date > b.date ? -1 : 1;
        });
      }
    }, (resp) => {
      this.bhvrintvs = [];
    });
  }
}
